import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";

const EditModal = ({
  technician,
  onClose,
  onSave,
  year,
  month,
  existingSchedule,
}) => {
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const days = [...Array(daysInMonth)].map((_, i) => i + 1);
  const [selectedShifts, setSelectedShifts] = useState({});

  // console.log(technician);

  // ✅ Pre-fill the existing schedule for this technician
  useEffect(() => {
    const shifts = {};
    for (let day = 1; day <= daysInMonth; day++) {
      const shift = existingSchedule[`${technician}-${day}`];
      if (shift) {
        shifts[day] = shift.split(","); // e.g. "D,N" → ["D", "N"]
      }
    }

    setSelectedShifts(shifts);
  }, [technician, existingSchedule, daysInMonth]);

  const toggleShift = (day, type) => {
    setSelectedShifts((prev) => {
      const current = prev[day] || [];

      // 🔴 If pressing OFF and OFF is the only selected shift → clear the day
      if (type === "OFF") {
        if (current.length === 1 && current[0] === "OFF") {
          const newState = { ...prev };
          delete newState[day]; // remove the day
          return newState;
        }
        // ✅ Otherwise, replace everything with OFF
        return { ...prev, [day]: ["OFF"] };
      }

      // 🟡 Remove OFF if present and toggle D/N
      const filtered = current.filter((s) => s !== "OFF");

      const updated = filtered.includes(type)
        ? filtered.filter((s) => s !== type)
        : [...filtered, type];

      const newState = { ...prev };
      if (updated.length > 0) {
        newState[day] = updated;
      } else {
        delete newState[day];
      }

      return newState;
    });
  };

  const handleSave = () => {
    const updates = {};
    Object.entries(selectedShifts).forEach(([day, shifts]) => {
      if (shifts && shifts.length > 0) {
        updates[`${technician}-${day}`] = shifts.join(",");
      }
    });
    onSave(updates);
  };

  return (
    <div className="tech-modal-backdrop">
      <div className="tech-modal-content">
        <h3>
          {technician} –{" "}
          {new Date(year, month).toLocaleDateString("en-GB", {
            year: "numeric",
            month: "long",
          })}
        </h3>

        <p>D · Day shift &nbsp; N · Night shift &nbsp; OFF · Off duty</p>
        <div className="tech-calendar-grid">
          {days.map((day) => (
            <div key={day} className="tech-calendar-day">
              <div className="tech-day-label">{day} <small>{new Date(year, month, day).toLocaleDateString("en-GB", { weekday: "short" })}</small></div>
              <button
                className={`tech-btn-shift ${
                  (selectedShifts[day] || []).includes("D")
                    ? "tech-selected-d"
                    : ""
                }`}
                onClick={() => toggleShift(day, "D")}
              >
                D
              </button>
              <button
                className={`tech-btn-shift ${
                  (selectedShifts[day] || []).includes("N")
                    ? "tech-selected-n"
                    : ""
                }`}
                onClick={() => toggleShift(day, "N")}
              >
                N
              </button>
              <button
                className={`tech-btn-shift ${
                  (selectedShifts[day] || []).includes("OFF")
                    ? "tech-selected-off"
                    : ""
                }`}
                onClick={() => toggleShift(day, "OFF")}
              >
                OFF
              </button>
            </div>
          ))}
        </div>

        <div style={{ marginTop: "1rem", textAlign: "right" }}>
          <Button onClick={handleSave}>SAVE</Button>
          <Button
            onClick={onClose}
            className="outline-secondary"
            style={{ marginLeft: "1rem" }}
          >
            CANCEL
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditModal;
